/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_RetailInputs */

const en_price_retail = /** @type {(inputs: Price_RetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retail`)
};

/**
* | output |
* | --- |
* | "Retail" |
*
* @param {Price_RetailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_retail = /** @type {((inputs?: Price_RetailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_RetailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_retail(inputs)
});